<template>
  <div>
    <Breadcrumbs main="matchTx.dashboard" title="shipApproval.header" />
    <b-container fluid>
        <div class="d-flex flex-row justify-content-between mr-5">
          <span class="ml-2 f-w-600" style="font-size: 22px;">{{ $t('shipApproval.header') }}</span>          
          <!-- <b-button  pill size="md" @click="shipShore" class="bg-primary mb-4" >
              <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('shipShore.header') }} </span>
          </b-button>  -->
          <div class="row">
              <router-link to="/dashboard/homePageAgent">
                  <feather  v-b-tooltip.hover :title="$t('homePageAgent.header')" type="home" class="mx-2"></feather>
              </router-link>
              <router-link to="/eBooking/agentBookingTx">
                  <feather  v-b-tooltip.hover :title="$t('homePageAgent.issueBooking')" type="book-open" class="mx-2"></feather>
              </router-link>
              <!-- <router-link to="/dashboard/shipApproval">
                  <feather  v-b-tooltip.hover :title="$t('homePageAgent.matching')" type="link" class="mx-2"></feather>
              </router-link> -->
              <router-link to="/process/shipShore">
                  <feather  v-b-tooltip.hover :title="$t('homePageAgent.shoreApproval')" type="tag" class="mx-2"></feather>
              </router-link>
          </div>          
        </div>


        <div>
        <div class="row justify-content-start ml-2">
          <feather 
              @click="refreshMatchTx" 
              class="text-primary" 
              type="refresh-cw"  
              size="25" 
              v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
          </feather>  
            <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
            <span class="text-primary"> {{ asOf }} </span>   
          </div>
        <b-table
          sticky-header
          head-variant="light"
          table-variant="info"
          show-empty
          responsive
          sort-icon-left
          stacked="md"      
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
        >
        <template #cell(addressReqr)="row" >
              <b-button  size="sm"  v-b-popover.hover.top="row.item.contReqrAddress" variant="outline-info">
                  {{ $t('matchTx.reqr') }}
              </b-button>
          </template>
          <template #cell(addressRels)="row" >
              <b-button  size="sm" v-b-popover.hover.top="row.item.contRelsAddress" variant="outline-info">
                  {{ $t('matchTx.rels') }}
              </b-button>
          </template>
        <template #cell(contImage)="row" >
            <b-button  size="sm" @click="openModalImage(row.item, row.index, $event.target )" class="m-1">
                {{ row.item.contNo }}
            </b-button>
          </template>
          <template #cell(bookingIdFile)="row" >
              <b-button  size="sm" @click="openBkgFile(row.item, row.index, $event.target )" class="m-1">
                  {{ row.item.bkgId }}
              </b-button>
          </template>
          <template #cell(actAgent)="row" >
            <b-button  v-show="row.item.actAgent.accept" size="sm" @click="actAgentAccept(row.item)" class="m-1">
              {{ $t('shipApproval.approve') }}
            </b-button>
            <b-button  v-show="row.item.actAgent.reject" size="sm" @click="actAgentReject(row.item)" class="m-1" variant="danger">
              {{ $t('shipApproval.reject') }}
            </b-button>
          </template>
          <template #empty>
              <h5>{{ $t('reuse.noRecord') }}</h5>
          </template>
        </b-table>
        <b-row>
          <div class="row col-sm-4 ">
            <b-col class="my-1 ml-3">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                class="my-0"
              ></b-pagination>
            </b-col>   
            <b-col sm="3" md="6" class="my-1">
              <b-form-group
                :label= "$t('require.perPage')"
                label-for="per-page-select"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-form-select
                  id="per-page-select"
                  v-model="perPage"
                  :options="pageOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </div>
        </b-row>
        <!-- Info modal Container Image-->
        <b-modal id="contModal" :title="modalTitle" ok-only @hide="resetInfoModal">
          <div class="gradient-yg p-1" >
              <div class="dashboard">
                  <div class="image-scroll-container">
                      <div class="image-scroll" ref="scrollContainer">
                          <div
                          class="image-item"
                          v-for="(image, index) in imageUriModal"
                          :key="image.id"
                          >
                          <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                          <span class="image-counter">{{ index + 1 }} of {{ imageUriModal.length }}</span>
                          </div>
                          <div v-if="imageUriModal.length === 0" class="no-images">
                          {{$t('approvedTrans.noImageYet') }}
                          </div>
                      </div>
                      <div class="scroll-controls" v-if="imageUriModal.length > 1">
                          <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                          <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                          <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                          <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                      </div>
                  </div>                        
              </div>
          </div>
        </b-modal>
        <b-modal
              id="actAgentRejectModal" 
              :title="$t('shipApproval.rejectTitle')"
              v-model="showAgentRejectModal"
              header-bg-variant="warning"
              header-text-variant="dark"
              body-bg-variant="light"
              body-text-variant="dark"
              hide-footer
            >
                <b-col cols="4">{{ $t('shipApproval.rejectRemark') }}</b-col>
                <b-col>
                  <b-form-input
                      id="remark-input"
                      v-model="remark"
                      type="search"
                      :placeholder="$t('shipApproval.rejectRemarkPh')"
                      class="text-info"
                      style="font-size: 16px;"
                  ></b-form-input>
                </b-col>

              <div class="w-100">
                <!-- <span class="float-left">{{$t('matchTx.bkgId')}} : </span> <span> {{ selectedBkgId }}</span>  -->
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-right"
                  @click="clickReject_OK"
                >
                  OK
                </b-button>
              </div>
            </b-modal>
      </div>
    </b-container>
  </div>
</template>
<script>
import { updateActive, getData,uaTxWallet,compNameEngByCompId, matchTxsAgent,updateStatus, updateMatchTx2StepN, bkgFileUri, saveWithId } from "../../firebase"
import {relsCost , reqrCost ,reuCost} from '../../constants/config'
import {getRandomInt} from "../../utilities/util" 
  export default {
    data() {
      return {
        asOf : this.$moment().format( "HH:mm,  DD-MM-YYYY"),
        compId : '',
        compNameEng : '',
        showAgentRejectModal: false,
        remark : '',
        selectedItem : '',
        items: [],
        fields: [
          { key: 'mTxId', label: this.$t('matchTx.mTxId'), sortable: true, },  
          { key: 'jobTypeReqr', label: this.$t('shipApproval.jobType'), sortable: true, 
              formatter: value => {
                return this.$t(`shipApproval.${value}`)
              }}, 
          { key: 'contImage', label: this.$t('container.contNo'), variant: 'info'},          
          { key: 'detDate', label: this.$t('matchTx.detDate'), sortable: true, }, 
          { key: 'contType', label: this.$t('matchTx.contType'), sortable: true, },
          { key: 'contSize', label: this.$t('matchTx.contSize'), sortable: true, },
          { key: 'contGrade', label: this.$t('matchTx.contGrade'), sortable: true, },
          { key: 'maxGross', label: this.$t('container.maxGross'), sortable: true, },
          { key: 'tare', label: this.$t('container.tare'), sortable: true, },
          { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, },
          { key: 'bookingIdFile', label: this.$t('matchTx.bkgId'), variant: 'info'},       
          { key: 'compNameLocalRels', label: this.$t('matchTx.compNameLocalRels'), sortable: true, },                
          { key: 'addressRels', label: this.$t('matchTx.address'), sortable: false,}, 
          // { key: 'contRelsAddress', label: this.$t('matchTx.contRelsAddress'), sortable: false, },
          { key: 'compNameLocalReqr', label: this.$t('matchTx.compNameLocalReqr'), sortable: true, },                
          { key: 'addressReqr', label: this.$t('matchTx.address'), sortable: false, },  
          //{ key: 'contReqrAddress', label: this.$t('matchTx.contReqrAddress'), sortable: false, },
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
              formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},
          { key: 'msReqr', label: this.$t('matchTx.matchStatus'), sortable: false,variant: 'warning',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
            }}, 
          { key: 'jbReqr', label: this.$t('matchTx.jobStatus'), sortable: true,variant: 'warning',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
            }}, 
          { key: 'actAgent', label: this.$t('matchTx.actions'),variant: 'warning' }
        ],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        imageUriModal: [],
        modalTitle : ''
      }
    },
    computed: {
    },
    mounted() {
      this.compId= localStorage.getItem("compId")
      compNameEngByCompId(this.compId , (nameEng)=>{
         // = agent (controlled menu by compId under (userCat = agent) when login/register)
        this.compNameEng = nameEng
        console.log(`compNameEng => ${nameEng}`)
        matchTxsAgent(nameEng, (res)=>{
        this.items = res
        this.totalRows = res.length
      })
      }) 
    },
    methods: {
      shipShore(){  
        this.$router.push('/process/shipShore')
      },
      async refreshMatchTx() {
        await matchTxsAgent(this.compNameEng , (res)=>{
          this.items = res
          this.totalRows = res.length
        })
        this.remark = '',
        this.selectedItem = ''
        this.asOf = this.$moment().format( "HH:mm,  DD-MM-YYYY")
      },

      async actAgentReject(item) {
        // console.log(`[actAgentReject], item =>  ${JSON.stringify(item, null, 2)}`)
        this.selectedItem = item
        this.showAgentRejectModal=true
      },
      async clickReject_OK(){
        if (this.remark == '' ) {
          this.$toasted.show( this.$t('shipApproval.addRejectRemark'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
        } else {
          this.selectedItem.txSearcher == "Release" ? await updateStatus('Require', this.selectedItem.reqrId, 'Require') : await updateStatus('Release', this.selectedItem.relsId, 'Release')// return  status of Poster for recycle.
          await updateMatchTx2StepN( 'MatchTx',this.selectedItem.mTxId , 2.1).then(async()=>{
            await this.saveShipReview(this.selectedItem , false)
            let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000, 90000)}`                
            if (this.selectedItem.txSearcher == "Reuse") {
              await updateStatus('Reuse', this.selectedItem.reqrId, 'Reject')
              await updateActive('Container', this.selectedItem.contId, true )
              await updateActive('Seal', this.selectedItem.sealNo, true )
              await uaTxWallet(reuCost, this.selectedItem.compIdReqr, slipId, "auto", "refund", "ships reject reuse", this.selectedItem.mTxId )   // Rels Refund  
            } else {
              if (this.selectedItem.txSearcher == "Release") {
                updateStatus('Require',this.selectedItem.reqrId, 'Require') // return  status of Poster for recycle.
                updateActive('Container', this.selectedItem.contId, true )
                await uaTxWallet(relsCost, this.selectedItem.compIdRels, slipId, "auto", "refund", "ships reject release", this.selectedItem.mTxId )   // Rels Refund  
              } else {
                updateStatus('Release', this.selectedItem.relsId, 'Release')
                await uaTxWallet(reqrCost, this.selectedItem.compIdReqr, slipId, "auto", "refund", "ships reject require",this.selectedItem.mTxId )  // Reqr Refund
              }
            }
            this.showAgentRejectModal= false
            await this.refreshMatchTx()
          })
        }
      },
    
      actAgentAccept(item) {
        this.$bvModal.msgBoxConfirm(this.$t('matchTx.confirmAcceptMsg'), {
          title: this.$t('shipApproval.plsConfirmApproval'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              if ( item.txSearcher == 'Reuse' || item.txSearcher == 'Transfer') {
                item.sealNo ? await updateMatchTx2StepN('MatchTx', item.mTxId, 6 , item.sealNo) :  await updateMatchTx2StepN('MatchTx',item.mTxId , 6)
              } else {
                // item.txSearcher == 'Reuse' ? await updateMatchTx2StepN('MatchTx', item.mTxId, 6 , item.sealNo) :  await updateMatchTx2StepN('MatchTx',item.mTxId , 3)
                await updateMatchTx2StepN('MatchTx',item.mTxId , 3)
              }
              await this.saveShipReview(item , true)
              await this.refreshMatchTx()
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Accept: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },
      async openModalImage(item, index, button) {
            await getData('Container' , 'contId' , item.contId , (res)=>{
            this.imageUriModal = res[0].url6  
            this.modalTitle = res[0].contNo   
            this.$root.$emit('bv::show::modal', "contModal" , button)                                  
            })
        },
        resetInfoModal() {
            this.modalTitle = ''
            this.imageUriModal = []
        },
       async openBkgFile(item, index, button) {   
          console.log(`bkgFile, bkgId => ${JSON.stringify(item.bkgId)}`)
            let fileUri = await bkgFileUri(item.bkgId , item.compIdReqr)        
            console.log(`bkgFile, fileUri => ${JSON.stringify(fileUri)}`)
            // window.location.href= fileUri
            window.open(fileUri)
        },
        async saveShipReview( item , isApprove){
            const data = {
                mTxId : item.mTxId,
                isApprove: isApprove,  
                agent: item.agent,                                
                bkgId: item.bkgId,                
                contNo : item.contNo,
                // imageUri : item.imageUri,                
                contType: item.contType,
                contSize: item.contSize,
                contGrade: item.contGrade,                               
                detDate : item.detDate,
                detTS : item.detTS,
                maxGross : item.maxGross,
                tare : item.tare,
                jobMethCat : item.txSearcher,                
                compIdReqr : item.compIdReqr,                
                compNameLocalReqr :item.compNameLocalReqr,   
                distance: item.distance,                
                compIdRels:item.compIdRels,                               
                compNameLocalRels:item.compNameLocalRels,                
                timestamp: Date.parse(new Date()),
                remark: this.remark                                     
            }
            await saveWithId('ShipReport', item.mTxId, data)
        },
        scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
  }
</script>
<style scoped>

.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
.display-image {
  width: 100%;
  height: 450px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}

  .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>